export default __webpack_public_path__ + "static/media/StaffPayLogo.ac9eaca0.png";